import { officeApi } from '../../officeApi'
import { ConvertToPdfPayload } from './types'

export async function convertToPdfRequest({
  file,
  abortController,
  onProgress
}: ConvertToPdfPayload): Promise<Blob> {
  const formData = new FormData()
  formData.append('file', file)

  const response = await officeApi.post('/lool/convert-to/pdf', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    responseType: 'blob',
    signal: abortController?.signal,
    onUploadProgress: ({ loaded, total }) => {
      if (onProgress && total) {
        onProgress((loaded / total) * 0.5)
      }
    },
    onDownloadProgress: ({ loaded, total }) => {
      if (onProgress && total) {
        const downloadProgress = loaded / total
        onProgress(0.5 + downloadProgress * 0.5)
      }
    }
  })

  return response.data
}
